/*=========================================================================================
  File Name: moduleCustomer.js
  Description: Customer Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleDishState.js'
import mutations from './moduleDishMutations.js'
import actions from './moduleDishActions.js'
import getters from './moduleDishGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}